import {featureFlags} from '@dms/feature-flags';

export const featureFlagsByAcl: Record<string, string> = {
  VAT_CALCULATION_DEFINITION: featureFlags.ACL_VAT_CALCULATION_DEFINITION,
  VAT_CHECK_TOTALS_DEFINITION: featureFlags.ACL_VAT_CHECK_DEFINITION,
  NEGATIVE_DOCUMENT_CANCELLATION_DEFINITION:
    featureFlags.ACL_NEGATIVE_DOCUMENT_CANCELLATION_DEFINITION,
};
